import { render, staticRenderFns } from "./CustomerResultsContainer.vue?vue&type=template&id=a639159e"
import script from "./CustomerResultsContainer.vue?vue&type=script&lang=js"
export * from "./CustomerResultsContainer.vue?vue&type=script&lang=js"
import style0 from "./CustomerResultsContainer.vue?vue&type=style&index=0&id=a639159e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports